import axios from 'axios';
import Cookies from 'js-cookie'
import router from '@/router';
import storeIndex from '@/store/index';
import signature  from '@/services/signature';
const BASE_URI = process.env.API_BASE_URI;

class AuthService {
    async login(user) {
        let data = {
            'email': user.username,
            'password': user.password,
            'remember': user.remember
        };
        return await axios.post(BASE_URI + '/v1/auth/login', data).then(response => {
            if(!response.data.data.encrypt_email){
                if (response.data.data.access_token) {
                    Cookies.set('centralToken', response.data.data.access_token, { domain: '.' + process.env.CENTRAL_API_ROOT })
                }
                if (data.remember) {
                    var encodepassword = storeIndex.b64EncodeUnicode(data.password);
                    Cookies.set('login_email', data.email, {expires: 30, domain: '.' + process.env.CENTRAL_API_ROOT });
                    Cookies.set('login_password', encodepassword, {expires: 30, domain: '.' + process.env.CENTRAL_API_ROOT });
                } else {
                    Cookies.remove('login_email', { domain: '.' + process.env.CENTRAL_API_ROOT });
                    Cookies.remove('login_password', { domain: '.' + process.env.CENTRAL_API_ROOT });
                }
                return { message: 'Failed login!' };
            }else{
                return { encrypt_email: response.data.data.encrypt_email };
            }
        });
    }
    async loginV2(param) {

        const saveToCookie = (string, keyName) => {
            const bytesPerCookie = 2000;
            
            const loop = Math.ceil(string.length / bytesPerCookie)

            if(loop === 0) {
                Cookies.set(`${keyName}-1`, "", { domain: '.' + process.env.CENTRAL_API_ROOT })
            } else {
                for (let index = 1; index <= loop; index++) {
                    const substring = string.substring((index - 1) * bytesPerCookie, index * bytesPerCookie)
                    Cookies.set(`${keyName}-${index}`, substring, { domain: '.' + process.env.CENTRAL_API_ROOT })
                }
            }

        }

        try {
            const data = {
                email: param.username,
                password: param.password,
            }
    
            const request = await axios.post(BASE_URI + '/v2/auth/login' + signature(), data)
    
            const {user, stores, invitation_list, migrations_count, total, announcement} = request.data.data

            const { access_token, ...body } = user
    
            Cookies.set('centralToken', access_token, { domain: '.' + process.env.CENTRAL_API_ROOT })
    
            if(param.remember) {
                const encodepassword = storeIndex.b64EncodeUnicode(data.password);
                Cookies.set('login_email', data.email, {expires: 30, domain: '.' + process.env.CENTRAL_API_ROOT });
                Cookies.set('login_password', encodepassword, {expires: 30, domain: '.' + process.env.CENTRAL_API_ROOT });
            }
            
            const {goship, gosell} = stores
            const storesLogo = {}

            const shortVal = {
              id : "i",
              domain : "d",
              last_login_date : "l",
              migrations_count : "m",
              name : "n",
              owners : "o",
              plan_group : "g",
              plan_serie : "s",
              progress : "p",
              role : "r",
              upgrading : "u",
              logo : "lo",
              status : "st",
              is_maintenance_mode : "is"
            }

            const goshipWihtOutLogo = goship.map(({logo,...item}) => {
              if(logo) storesLogo[item.id] = logo
              const obj = {}
              for (const [key, value] of Object.entries(item)) {
                  obj[shortVal[key]] = value
              }
              obj.lo = logo ? 'loading' : ''
              return obj
            })

            const gosellWihtOutLogo = gosell.map(({logo,...item}) => {
              if(logo) storesLogo[item.id] = logo
              const obj = {}
              for (const [key, value] of Object.entries(item)) {
                  obj[shortVal[key]] = value
              }
              obj.lo = logo ? 'loading' : ''
              return obj
            })

            const shortInvitation = {
              id : "i",
              invited_by : "in",
              tenant_name : "t",
            }

            const formatInvitation = invitation_list.map(item => {
              const obj = {}
              for (const [key, value] of Object.entries(item)) {
                  obj[shortInvitation[key]] = value
              }
              return obj
            })

            const shortUser = {
              id : "i",
              global_id : "gi",
              first_name : "fn",
              last_name : "ln",
              email : "e",
              mobile : "m",
              store_limit : "s",
              user_data : "u"
            }

            const formatuser = {}
            for (const [key, value] of Object.entries(body)) {
              formatuser[shortUser[key]] = value
            }

            console.log({goshipWihtOutLogo, gosellWihtOutLogo, storesLogo, formatInvitation, formatuser})

            const user2string = JSON.stringify(formatuser) 

            const goship2string =  JSON.stringify(goshipWihtOutLogo) 

            const gosell2string = JSON.stringify(gosellWihtOutLogo) 
           
            const invitation2string = JSON.stringify(formatInvitation)  

            saveToCookie(user2string, 'userProfile')
            saveToCookie(goship2string, 'goshipStoreList')
            saveToCookie(gosell2string, 'gosellStoreList')
            saveToCookie(invitation2string, 'invitation')
            Cookies.set(`totalStores`, JSON.stringify(total) , { domain: '.' + process.env.CENTRAL_API_ROOT })
            Cookies.set(`announcement`, JSON.stringify(announcement) , { domain: '.' + process.env.CENTRAL_API_ROOT })
            Cookies.set(`migrations_count`, migrations_count , { domain: '.' + process.env.CENTRAL_API_ROOT })
            localStorage.storesLogo = JSON.stringify(storesLogo)

            return  body

        } catch (error) {
            console.log({error})
            if("response" in error && error.response.status === 403) {
                return error.response.data
            }
            if(error.response.status === 400 && error.response.data.message == 'Your timestamp outdate') {
                return {
                    message : "Your device's clock is not current. Please enable automatic time setting on your device."
                }
            }

            if(error.response.status === 400 && error.response.data.message == 'User has been blocked.') {
                return {
                    message : "You have been blocked from the system. Please contact the admin."
                }
            }

            return {
                message : "The page you're looking for is currently updating with a new version and will be back soon. Please try again later."
            } 
        }
    }
    logout() {
        Cookies.remove('centralToken', { domain: '.' + process.env.CENTRAL_API_ROOT })
    }
    async register(user) {
        if (user.socialLogin) {
            var registerUrl = '/v1/auth/register-social';
        } else {
            var registerUrl = '/v1/auth/register';
        }
        if(router.currentRoute.query.refer != undefined) {
            registerUrl += '?refer=' + router.currentRoute.query.refer;
        }
        return await axios.post(BASE_URI + registerUrl, {
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            mobile: user.mobile,
            password: user.password,
            password_confirmation: user.password_confirmation,
            coupon: user.coupon,
            ref: user.ref,
            mcode: user.mcode,
            uuid: user.uuid,
            utm_source: user.utm_source,
            utm_medium: user.utm_medium,
            utm_campaign: user.utm_campaign,
            utm_referer: user.utm_referer,
            utm_adsid: user.utm_adsid,
            socialLogin:user.socialLogin,
            socialLoginStateWebsocket: user.socialLoginStateWebsocket
        }).then(response => {
            if (response.data.data.access_token) {
                Cookies.set('centralToken', response.data.data.access_token, { domain: '.' + process.env.CENTRAL_API_ROOT })
            }
            return response
        })
    }
}

export default new AuthService()



// WEBPACK FOOTER //
// ./src/services/auth.service.js